export default "__VITE_ASSET__CM2rcb1H__"